<div class="container" role="tablist" (keydown)="onKeydown($event)">
	<app-tab *ngFor="let tab of tabSet; let i = index; trackBy: trackByLabel" [label]="tab.label"
		[selected]="tab.selected" [tabIndexValue]="i === focusedIndex ? 0 : -1" (selectTab)="selectTab(tab)"></app-tab>
</div>